import ffc from "../../apis/ffc";

export default {
  get_form({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.get_form(payload);
        commit("GET_FORM", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_form({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.add_form(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_form({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.update_form(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_form({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.delete_form(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////////////////////////////
  ////////////////////////////BANNER//////////////////////////////////
  /////////////////////////////////////////////////////////////////////

  get_banner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.get_banner(payload);
        commit("GET_BANNER", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_banner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.add_banner(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_banner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.update_banner(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_banner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.delete_banner(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////////////////////////////
  ////////////////////////////PARTNER/////////////////////////////////
  /////////////////////////////////////////////////////////////////////

  get_partner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log(payload);
        const { data } = await ffc.get_partner(payload);
        commit("GET_PARTNER", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_partner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.add_partner(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_partner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.update_partner(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_partner({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.delete_partner(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  /////////////////////////////////////////////////////////////////////////////
  ////////////////////////////TESTIMONIAL//////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////

  get_testimonial({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.get_testimonial(payload);
        commit("GET_TESTIMONIAL", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getall_testimonial({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.getall_testimonial(payload);
        commit("GET_ALL_TESTIMONIAL", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_testimonial({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.add_testimonial(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_testimonial({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.update_testimonial(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_testimonial({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.delete_testimonial(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////////////////////////
  ////////////////////////////HUB//////////////////////////////////
  /////////////////////////////////////////////////////////////////

  get_hub({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.get_hub(payload);
        commit("GET_HUB", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_hub({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.add_hub(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_hub({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.update_hub(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_hub({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.delete_hub(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////////////////////////
  ////////////////////////////REVIEW//////////////////////////////
  /////////////////////////////////////////////////////////////////

  get_review({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.get_review(payload);
        commit("GET_REVIEW", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  add_review({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.add_review(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  update_review({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.update_review(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  delete_review({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.delete_review(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  ///////////////////////////////////////////////////////////////////
  ////////////////////////////CORPORATE EVENTS///////////////////////
  /////////////////////////////////////////////////////////////////

  getCorporateEvents({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.getCorporateEvents(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  addCorporateEvents({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.addCorporateEvents(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  editCorporateEvents({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.editCorporateEvents(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteCorporateEvents({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.deleteCorporateEvents(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////////////////////////
  ////////////////////////////FUTURE TRENDS///////////////////////
  /////////////////////////////////////////////////////////////////

  getFutureTrends({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.getFutureTrends(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  addFutureTrends({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.addFutureTrends(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  editFutureTrends({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.editFutureTrends(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteFutureTrends({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.deleteFutureTrends(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////////////////////////
  ////////////////////////////ffc PODCAST///////////////////////
  /////////////////////////////////////////////////////////////////

  getPodcast({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.getPodcast(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  addPodcast({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.addPodcast(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  editPodcast({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.editPodcast(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deletePodcast({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.deletePodcast(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  ///////////////////////////////////////////////////////////////////
  ////////////////////////////ffc Event Registration///////////////////////
  /////////////////////////////////////////////////////////////////

  getEventReg({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.getEventReg(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  addEventReg({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.addEventReg(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  editEventReg({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.editEventReg(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteEventReg({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await ffc.deleteEventReg(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
